<template>
  <div id="app">
    <div v-if="$root.loadApp">
      <v-loading v-if="$root.showLoading" :texto="$root.textLoading"></v-loading>
      <header-component></header-component>

      <transition name="slide-fade" mode="out-in">
        <router-view />
      </transition>
      <footer-component></footer-component>
    </div>
    <div v-else>
      <v-loading v-if="$root.showLoading" :texto="$root.textLoading"></v-loading>
    </div>
    <div id="form-transparent" style="display: none;"></div>
  </div>
</template>

<script>
import HeaderComponent from './components/includes/Header.vue'
import FooterComponent from './components/includes/Footer.vue'
export default {
  name: 'App',
  components: {
    HeaderComponent,
    FooterComponent,
  },
  beforeCreate() {
    console.info('Carregando App...')
    $(() => {
      $.modal.defaults.fadeDuration = 500
      $.modal.defaults.escapeClose = false
      $.modal.defaults.clickClose = false
      $.modal.defaults.showClose = false
    })
  },
  mounted() {
    !function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s)
    }(window, document, 'script','https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '548558621233826');
    fbq('track', 'PageView');
  },
}
</script>

<style lang="css">
@import "assets/css/app.css";

.slide-fade-slow-enter-active {
  transition: all 1s ease;
}

.slide-fade-slow-leave-active {
  transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-slow-enter,
.slide-fade-slow-leave-to {
  transform: translateX(20px);
  opacity: 0;
}

.slide-fade-enter-active {
  transition: all .1s ease;
}

.slide-fade-leave-active {
  transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(20px);
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity .2s
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active in <2.1.8 */
  {
  opacity: 0
}
</style>



// WEBPACK FOOTER //
// src/App.vue